import Chevron from 'icons/Chevron';
import Clickable, { ClickableProps } from './Clickable';
import styles from './styles/TextLink.module.scss';
import cn from 'classnames';

export enum TextLinkSize {
  INHERIT = 'Inherit',
  SMALL = 'Small',
  MEDIUM = 'Medium',
  LARGE = 'Large'
}

export enum TextColorVariant {
  BLUE = 'Blue',
  BLACK = 'Black'
}

export type TextLinkProps = ClickableProps & {
  size?: TextLinkSize;
  forward?: boolean;
  color?: TextColorVariant;
};

export default function TextLink({
  size = TextLinkSize.MEDIUM,
  className,
  children,
  forward,
  color = TextColorVariant.BLUE,
  ...props
}: TextLinkProps) {
  return (
    <Clickable className={cn(styles.TextLink, size != TextLinkSize.INHERIT && styles[size], styles[color], className)} {...props}>
      {children && (
        <>
          {children}
          {forward && <Chevron height={12} width={6} color="#2776ea" />}
        </>
      )}
    </Clickable>
  );
}
